import { useState } from "react";

export function useSearch(roles) {
  const [search, setSearch] = useState("");

  const getFilteredRoles = () => {
    if (search.trim()) {
      let foundRoles = {};

      for (let orgName in roles) {
        let rolesPerOrg = roles[orgName];
        let filteredRoles = rolesPerOrg.filter((role) =>
          role.name.toLowerCase().includes(search.toLowerCase())
        );
        if (filteredRoles.length) {
          foundRoles[orgName] = filteredRoles;
        }
      }

      return foundRoles;
    }
    return roles;
  };

  const filteredRoles = getFilteredRoles();

  return { search, setSearch, filteredRoles };
}
